import React, { useEffect, useState } from "react";

import { datadogRum } from "@datadog/browser-rum";
import { asyncWithLDProvider } from "launchdarkly-react-client-sdk";

import LogoLoadingStill from "@src/sharedComponents/LogoLoadingStill/LogoLoadingStill";

export const LDProvider: React.FC<React.PropsWithChildren<unknown>> = ({
  children,
}) => {
  const [LDProvider, setLDProvider] = useState<React.ComponentType<{
    children: React.ReactNode;
  }> | null>(null);

  useEffect(() => {
    async function initLD() {
      const provider = await asyncWithLDProvider({
        clientSideID:
          process.env.WEBAPP_ENV === "PROD"
            ? "63f4fd7a6f94d413bae7db57"
            : "63f4fd7a6f94d413bae7db56",
        options: {
          evaluationReasons: true,
          streaming: true,
          application: { id: "Glacier", version: process.env.COMMIT_SHA_FULL },
          inspectors: [
            {
              type: "flag-used",
              name: "dd-inspector",
              method: (key, detail) => {
                datadogRum.addFeatureFlagEvaluation(key, detail.value);
              },
            },
          ],
        },
      });

      setLDProvider(() => provider);
    }

    initLD();
  }, []);

  return LDProvider ? (
    <LDProvider>{children}</LDProvider>
  ) : (
    <LogoLoadingStill onTop />
  );
};
